module.exports = __webpack_public_path__ + "img/79800.52de51cc.jpg";